import { Widget, WidgetHeader } from './shared';
import t from '../../../util/translation/translation';
import { Link } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import CUSTOM_VIDEO_ICON from 'mdi-react/PlayCircleOutlineIcon';
import Calendar from 'mdi-react/CalendarIcon';
import BullHorn from 'mdi-react/BullhornOutlineIcon';
import Gift from 'mdi-react/GiftIcon';
import ImageIcon from 'mdi-react/ImageIcon';
import NewsIcon from 'mdi-react/NewspaperIcon';
import Comment from 'mdi-react/CommentIcon';
import BellIcon from 'mdi-react/BellIcon';
import BullhornOutlineIcon from 'mdi-react/BullhornOutlineIcon';

const getIconComponent = (type) => {
  switch (type) {
    case 'Calendar':
      return Calendar;
    case 'BullHorn':
      return BellIcon;
    case 'Gift':
      return Gift;
    case 'ImageIcon':
      return BullhornOutlineIcon;
    case 'NewsIcon':
      return NewsIcon;
    case 'Comment':
      return Comment;
    default:
      return null;
  }
};

const Tile = ({ icon, link, title, color }) => {
  let IconComponent = getIconComponent(icon);
  return (
    <Link to={link} className="mr-2" style={{ display: 'inline-block' }}>
      <div
        style={{
          backgroundColor: 'white',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: 8,
          color: 'black',
          borderRadius: 8,
          width: 140,
          heigh: 120,
          border: '1px solid #D7DAE0',
          backgroundColor: '#F9FAFB',
        }}
      >
        <div
          style={{
            margin: '15px auto',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div
            style={{
              backgroundColor: color ? color : '#d7e9feff',
              width: 56,
              height: 56,
              borderRadius: 12,
              paddingTop: 13,
              paddingLeft: 13,
            }}
          >
            <IconComponent
              style={{
                borderRadius: 6,
                fill: '#fff',
              }}
              size={30}
            />
          </div>
          <p
            style={{
              fontSize: 12,
              fontWeight: 700,
              lineHeight: '12px',
              color: 'black',
            }}
          >
            {title}
          </p>
        </div>
      </div>
    </Link>
  );
};

const UpcomingGames = () => {
  return (
    <Widget>
      <WidgetHeader
        bottomSpace="sm"
        title={t('DashboardPage.shortcuts')}
        subhead={t('DashboardPage.shortcutsSub')}
      />
      <div className="py-2">
        <div className="">
          <Tile
            color="#0469DC"
            link="/news/create"
            icon="NewsIcon"
            title={t('AppLayout.newsTile')}
          />
          <Tile
            color="#703FF3"
            link="/events/create"
            icon="Calendar"
            title={t('AppLayout.eventsTile')}
          />
          <Tile
            color="#ED9E45"
            link="/messages"
            icon="BullHorn"
            title={t('AppLayout.pushNotification')}
          />
          <Tile
            color="#EB4747"
            link="/spotlight/group/create"
            icon="ImageIcon"
            title={t('AppLayout.spotlightTile')}
          />
          <Tile
            color="#2CC975"
            link="/questionnaires/create"
            icon="Comment"
            title={t('AppLayout.questionairesTile')}
          />
          <Tile
            color="#399351"
            link="/offers/create"
            icon="Gift"
            title={t('AppLayout.offersTile')}
          />
        </div>
      </div>
    </Widget>
  );
};

export default UpcomingGames;
